import { MimeTypes } from 'constants/enums';

const generateFileName = (
  url: string | null | undefined,
  fileType: string | null | undefined
): string => {
  let fileExtension = '';

  switch (fileType) {
    case MimeTypes.docx:
      fileExtension = 'docx';
      break;
    case MimeTypes.doc:
      fileExtension = 'doc';
      break;

    case MimeTypes.jpg:
    case MimeTypes.jpeg:
      fileExtension = 'jpg';
      break;
    case MimeTypes.png:
      fileExtension = 'png';
      break;
    case MimeTypes.pdf:
    default:
      fileExtension = 'pdf';
      break;
  }

  const fileName = (url || '').split('/').pop()?.split('.')[0] || 'document';

  return `${fileName}.${fileExtension}`;
};

export default generateFileName;
